<template>
  <v-flex xs12>
    <span v-if="label">{{ label }}</span>
    <v-layout
      align="center"
      justify="end"
    >
      <v-flex
        xs12
        md6
      >
        <date-picker
          v-model="payload.dataInicial"
          :input-key="`${inputKey}${$t('support.components.reports.initialDate')}First`"
          :rules="[dateLesserThan(payload.dataFinal)]"
          :label="initialDateLabel || $t('support.components.reports.initialDate')"
          :required="required"
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <date-picker
          v-model="payload.dataFinal"
          :input-key="`${inputKey}${$t('support.components.reports.finalDate')}Second`"
          :rules="[dateGreaterThan(payload.dataInicial)]"
          :label="finalDateLabel || $t('support.components.reports.finalDate')"
          :required="required"
        />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import RulesMixin from 'Support/mixins/rules-mixin';

export default {
  name: 'DateInterval',
  components: {
    DatePicker,
  },
  mixins: [RulesMixin],
  props: {
    inputKey: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    initialDateLabel: {
      type: String,
      default: '',
    },
    finalDateLabel: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    payload: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
